import { defineNuxtPlugin } from '#app/nuxt'
import { LazyCaptcha, LazyCmsGenericBlock, LazyCmsGenericSidebarBlock, LazyCmsPage, LazyCookieConsentBanner, LazyCookiePreferencesModal, LazyFrontendAccountCustomerGroupRegistrationPage, LazyFrontendBlogPost, LazyFrontendDetailPage, LazyFrontendLandingPage, LazyFrontendNavigationPage, LazyLanguageSwitcher, LazyPageResolverContent, LazyPaymentMethods, LazyPersonalConsultation, LazyProductAddToCart, LazySocialShare, LazyUnsupportedIPadOSBanner, LazyVideoPopup, LazyVoucherBox, LazyVoucherCard, LazyAccountAddressCard, LazyAccountAddressForm, LazyAccountChangeEmail, LazyAccountChangePassword, LazyAccountLoginForm, LazyAccountMenu, LazyAccountOrder, LazyAccountOrderDetails, LazyAccountOrderDownloads, LazyAccountOrderLineItem, LazyAccountOrderSummary, LazyAccountPersonalData, LazyAccountRecoverPassword, LazyAccountRegisterForm, LazyAccountResetPasswordForm, LazyAccountOrderLineItemCredit, LazyAccountOrderLineItemCustom, LazyAccountOrderLineItemProduct, LazyAccountOrderLineItemPromotion, LazyAccountOrderStatus, LazyBlogCommentsList, LazyCheckoutAddressCard, LazyCheckoutCartItem, LazyCheckoutLoginForm, LazyCheckoutPayments, LazyCheckoutPromotionCode, LazyCheckoutRegistration, LazyCheckoutShipping, LazyCheckoutSideCart, LazyCheckoutSteps, LazyCheckoutCartProductItem, LazyCheckoutCartPromotionItem, LazyCheckoutCartPseudoItemIcon, LazyCheckoutCartSideProductItem, LazyCmsBlockCrossSelling, LazyCmsBlockGalleryBuybox, LazyCmsBlockMsbBlogBlock, LazyCmsBlockMysofaGlossaryText, LazyCmsBlockProductListing, LazyCmsBlockProductSlider, LazyCmsBlockSidebarFilter, LazyCmsElementAboutVideoDescription, LazyCmsElementBreadCrumb, LazyCmsElementBuyBox, LazyCmsElementCategoryBanner, LazyCmsElementCategoryDescriptionSeo, LazyCmsElementCategoryGrid, LazyCmsElementCategoryList, LazyCmsElementCategoryNavigation, LazyCmsElementCrossSelling, LazyCmsElementFaqManagerCategories, LazyCmsElementForm, LazyCmsElementGalleryWithLogo, LazyCmsElementHorizontalLine, LazyCmsElementImageGallery, LazyCmsElementInfoFaq, LazyCmsElementJobList, LazyCmsElementLeftTextRightImage, LazyCmsElementManufactureInfoBlock, LazyCmsElementMap, LazyCmsElementMsbBlog, LazyCmsElementProductDescriptionReviews, LazyCmsElementProductGrid, LazyCmsElementProductListing, LazyCmsElementProductSlider, LazyCmsElementRecentlyViewed, LazyCmsElementReview, LazyCmsElementReviewList, LazyCmsElementReviewSideBar, LazyCmsElementSampleRequest, LazyCmsElementServiceFeatures, LazyCmsElementShippingContent, LazyCmsElementShowRoomList, LazyCmsElementShowroom3GridContentBlock, LazyCmsElementShowroom4GridContentBlock, LazyCmsElementShowroomCard, LazyCmsElementShowroomTabSection, LazyCmsElementSidebarFilter, LazyCmsElementSubCategorySlider, LazyCmsElementTextDescription, LazyCmsElementVideoDescription, LazyCmsElementVoucherPage, LazyCmsSectionDefault, LazyCmsSectionSidebar, LazyErrorsMaintainMode, LazyErrorsRoutingNotFound, LazyFormsBlogCommentForm, LazyFormsEnquiryForm, LazyFormsSampleRequestForm, LazyFormsSwContactForm, LazyFormsSwNewsletterForm, LazyFormsSwNewsletterFormFooter, LazyLayoutBreadcrumbs, LazyLayoutCheckoutFooter, LazyLayoutCheckoutHeader, LazyLayoutFooter, LazyLayoutHeader, LazyLayoutNotification, LazyLayoutNotifications, LazyLayoutProductBreadcrumbs, LazyLayoutSideMenu, LazyLayoutSidebar, LazyLayoutStoreSearch, LazyLayoutTopNavigation, LazyLayoutTopNavigationRecursive, LazyLayoutFooterBackToTop, LazyLayoutFooterCopyright, LazyLayoutFooterCustomerService, LazyLayoutFooterHorizontalLine, LazyLayoutFooterNavigationMenu, LazyLayoutFooterOverlay, LazyLayoutFooterPaymentMethods, LazyLayoutFooterPaymentMethodsMobile, LazyLayoutFooterSocialMedia, LazyLayoutHeaderInformationBanner, LazyLayoutHeaderMenuScroll, LazyLayoutHeaderPromotion, LazyLayoutHeaderRatingWidget, LazyLayoutHeaderSidebarInformation, LazyLayoutHeaderUserActions, LazyListingFiltersListingFilter, LazyListingFilters, LazyListingFiltersPrice, LazyListingFiltersProperties, LazyListingFiltersRating, LazyListingFiltersShippingFree, LazyListingFiltersSwProductListingFilter, LazyListingFiltersSwProductListingFilters, LazyProductCustomConfigurator, LazyProductCard, LazyProductGalleryModal, LazyProductReviews, LazyProductReviewsForm, LazyProductSuggestSearch, LazyProductUnits, LazyProductSwVariantConfigurator, LazyProductConfiguratorAttributeDisplay, LazyProductConfiguratorAttributeExtentedDisplay, LazyProductConfiguratorBundleListing, LazyProductConfiguratorConfigListing, LazyProductConfiguratorConfigurationItems, LazyProductConfiguratorLeatherPrice, LazyProductConfiguratorPriceSummary, LazyProductConfiguratorZoomModel, LazyProductConfiguratorDisplaysImageDisplay, LazyProductConfiguratorDisplaysRadioDisplay, LazyProductConfiguratorDisplaysTextDisplay, LazySharedCmsTextRender, LazySharedGlossaryModal, LazySharedIntlTelInput, LazySharedProductRating, LazySharedAccountAddressForm, LazySharedAddressSelectionModal, LazySharedButton, LazySharedCountryStateInput, LazySharedImage, LazySharedLandingPageLink, LazySharedListingProductPrice, LazySharedModal, LazySharedPagination, LazySharedPrice, LazySharedYoutubeVideo, LazySkeletonsDefault, LazySkeletonsProductCard, LazyCmsGenericElement, LazyCmsNoComponent, LazyCmsBlockCategoryNavigation, LazyCmsBlockCenterText, LazyCmsBlockCustomForm, LazyCmsBlockDefault, LazyCmsBlockForm, LazyCmsBlockImage, LazyCmsBlockImageBubbleRow, LazyCmsBlockImageCover, LazyCmsBlockImageFourColumn, LazyCmsBlockImageGallery, LazyCmsBlockImageHighlightRow, LazyCmsBlockImageSimpleGrid, LazyCmsBlockImageSlider, LazyCmsBlockImageText, LazyCmsBlockImageTextBubble, LazyCmsBlockImageTextCover, LazyCmsBlockImageTextGallery, LazyCmsBlockImageTextRow, LazyCmsBlockImageThreeColumn, LazyCmsBlockImageThreeCover, LazyCmsBlockImageTwoColumn, LazyCmsBlockProductDescriptionReviews, LazyCmsBlockProductHeading, LazyCmsBlockProductThreeColumn, LazyCmsBlockText, LazyCmsBlockTextHero, LazyCmsBlockTextOnImage, LazyCmsBlockTextTeaser, LazyCmsBlockTextTeaserSection, LazyCmsBlockTextThreeColumn, LazyCmsBlockTextTwoColumn, LazyCmsBlockVimeoVideo, LazyCmsBlockYoutubeVideo, LazyCmsElementCustomForm, LazyCmsElementImage, LazyCmsElementImageGallery3dPlaceholder, LazyCmsElementImageSlider, LazyCmsElementManufacturerLogo, LazyCmsElementProductBox, LazyCmsElementProductName, LazyCmsElementText, LazyCmsElementVimeoVideo, LazyCmsElementYoutubeVideo, LazyProductCardSkeleton } from '#components'
const lazyGlobalComponents = [
  ["Captcha", LazyCaptcha],
["CmsGenericBlock", LazyCmsGenericBlock],
["CmsGenericSidebarBlock", LazyCmsGenericSidebarBlock],
["CmsPage", LazyCmsPage],
["CookieConsentBanner", LazyCookieConsentBanner],
["CookiePreferencesModal", LazyCookiePreferencesModal],
["FrontendAccountCustomerGroupRegistrationPage", LazyFrontendAccountCustomerGroupRegistrationPage],
["FrontendBlogPost", LazyFrontendBlogPost],
["FrontendDetailPage", LazyFrontendDetailPage],
["FrontendLandingPage", LazyFrontendLandingPage],
["FrontendNavigationPage", LazyFrontendNavigationPage],
["LanguageSwitcher", LazyLanguageSwitcher],
["PageResolverContent", LazyPageResolverContent],
["PaymentMethods", LazyPaymentMethods],
["PersonalConsultation", LazyPersonalConsultation],
["ProductAddToCart", LazyProductAddToCart],
["SocialShare", LazySocialShare],
["UnsupportedIPadOSBanner", LazyUnsupportedIPadOSBanner],
["VideoPopup", LazyVideoPopup],
["VoucherBox", LazyVoucherBox],
["VoucherCard", LazyVoucherCard],
["AccountAddressCard", LazyAccountAddressCard],
["AccountAddressForm", LazyAccountAddressForm],
["AccountChangeEmail", LazyAccountChangeEmail],
["AccountChangePassword", LazyAccountChangePassword],
["AccountLoginForm", LazyAccountLoginForm],
["AccountMenu", LazyAccountMenu],
["AccountOrder", LazyAccountOrder],
["AccountOrderDetails", LazyAccountOrderDetails],
["AccountOrderDownloads", LazyAccountOrderDownloads],
["AccountOrderLineItem", LazyAccountOrderLineItem],
["AccountOrderSummary", LazyAccountOrderSummary],
["AccountPersonalData", LazyAccountPersonalData],
["AccountRecoverPassword", LazyAccountRecoverPassword],
["AccountRegisterForm", LazyAccountRegisterForm],
["AccountResetPasswordForm", LazyAccountResetPasswordForm],
["AccountOrderLineItemCredit", LazyAccountOrderLineItemCredit],
["AccountOrderLineItemCustom", LazyAccountOrderLineItemCustom],
["AccountOrderLineItemProduct", LazyAccountOrderLineItemProduct],
["AccountOrderLineItemPromotion", LazyAccountOrderLineItemPromotion],
["AccountOrderStatus", LazyAccountOrderStatus],
["BlogCommentsList", LazyBlogCommentsList],
["CheckoutAddressCard", LazyCheckoutAddressCard],
["CheckoutCartItem", LazyCheckoutCartItem],
["CheckoutLoginForm", LazyCheckoutLoginForm],
["CheckoutPayments", LazyCheckoutPayments],
["CheckoutPromotionCode", LazyCheckoutPromotionCode],
["CheckoutRegistration", LazyCheckoutRegistration],
["CheckoutShipping", LazyCheckoutShipping],
["CheckoutSideCart", LazyCheckoutSideCart],
["CheckoutSteps", LazyCheckoutSteps],
["CheckoutCartProductItem", LazyCheckoutCartProductItem],
["CheckoutCartPromotionItem", LazyCheckoutCartPromotionItem],
["CheckoutCartPseudoItemIcon", LazyCheckoutCartPseudoItemIcon],
["CheckoutCartSideProductItem", LazyCheckoutCartSideProductItem],
["CmsBlockCrossSelling", LazyCmsBlockCrossSelling],
["CmsBlockGalleryBuybox", LazyCmsBlockGalleryBuybox],
["CmsBlockMsbBlogBlock", LazyCmsBlockMsbBlogBlock],
["CmsBlockMysofaGlossaryText", LazyCmsBlockMysofaGlossaryText],
["CmsBlockProductListing", LazyCmsBlockProductListing],
["CmsBlockProductSlider", LazyCmsBlockProductSlider],
["CmsBlockSidebarFilter", LazyCmsBlockSidebarFilter],
["CmsElementAboutVideoDescription", LazyCmsElementAboutVideoDescription],
["CmsElementBreadCrumb", LazyCmsElementBreadCrumb],
["CmsElementBuyBox", LazyCmsElementBuyBox],
["CmsElementCategoryBanner", LazyCmsElementCategoryBanner],
["CmsElementCategoryDescriptionSeo", LazyCmsElementCategoryDescriptionSeo],
["CmsElementCategoryGrid", LazyCmsElementCategoryGrid],
["CmsElementCategoryList", LazyCmsElementCategoryList],
["CmsElementCategoryNavigation", LazyCmsElementCategoryNavigation],
["CmsElementCrossSelling", LazyCmsElementCrossSelling],
["CmsElementFaqManagerCategories", LazyCmsElementFaqManagerCategories],
["CmsElementForm", LazyCmsElementForm],
["CmsElementGalleryWithLogo", LazyCmsElementGalleryWithLogo],
["CmsElementHorizontalLine", LazyCmsElementHorizontalLine],
["CmsElementImageGallery", LazyCmsElementImageGallery],
["CmsElementInfoFaq", LazyCmsElementInfoFaq],
["CmsElementJobList", LazyCmsElementJobList],
["CmsElementLeftTextRightImage", LazyCmsElementLeftTextRightImage],
["CmsElementManufactureInfoBlock", LazyCmsElementManufactureInfoBlock],
["CmsElementMap", LazyCmsElementMap],
["CmsElementMsbBlog", LazyCmsElementMsbBlog],
["CmsElementProductDescriptionReviews", LazyCmsElementProductDescriptionReviews],
["CmsElementProductGrid", LazyCmsElementProductGrid],
["CmsElementProductListing", LazyCmsElementProductListing],
["CmsElementProductSlider", LazyCmsElementProductSlider],
["CmsElementRecentlyViewed", LazyCmsElementRecentlyViewed],
["CmsElementReview", LazyCmsElementReview],
["CmsElementReviewList", LazyCmsElementReviewList],
["CmsElementReviewSideBar", LazyCmsElementReviewSideBar],
["CmsElementSampleRequest", LazyCmsElementSampleRequest],
["CmsElementServiceFeatures", LazyCmsElementServiceFeatures],
["CmsElementShippingContent", LazyCmsElementShippingContent],
["CmsElementShowRoomList", LazyCmsElementShowRoomList],
["CmsElementShowroom3GridContentBlock", LazyCmsElementShowroom3GridContentBlock],
["CmsElementShowroom4GridContentBlock", LazyCmsElementShowroom4GridContentBlock],
["CmsElementShowroomCard", LazyCmsElementShowroomCard],
["CmsElementShowroomTabSection", LazyCmsElementShowroomTabSection],
["CmsElementSidebarFilter", LazyCmsElementSidebarFilter],
["CmsElementSubCategorySlider", LazyCmsElementSubCategorySlider],
["CmsElementTextDescription", LazyCmsElementTextDescription],
["CmsElementVideoDescription", LazyCmsElementVideoDescription],
["CmsElementVoucherPage", LazyCmsElementVoucherPage],
["CmsSectionDefault", LazyCmsSectionDefault],
["CmsSectionSidebar", LazyCmsSectionSidebar],
["ErrorsMaintainMode", LazyErrorsMaintainMode],
["ErrorsRoutingNotFound", LazyErrorsRoutingNotFound],
["FormsBlogCommentForm", LazyFormsBlogCommentForm],
["FormsEnquiryForm", LazyFormsEnquiryForm],
["FormsSampleRequestForm", LazyFormsSampleRequestForm],
["FormsSwContactForm", LazyFormsSwContactForm],
["FormsSwNewsletterForm", LazyFormsSwNewsletterForm],
["FormsSwNewsletterFormFooter", LazyFormsSwNewsletterFormFooter],
["LayoutBreadcrumbs", LazyLayoutBreadcrumbs],
["LayoutCheckoutFooter", LazyLayoutCheckoutFooter],
["LayoutCheckoutHeader", LazyLayoutCheckoutHeader],
["LayoutFooter", LazyLayoutFooter],
["LayoutHeader", LazyLayoutHeader],
["LayoutNotification", LazyLayoutNotification],
["LayoutNotifications", LazyLayoutNotifications],
["LayoutProductBreadcrumbs", LazyLayoutProductBreadcrumbs],
["LayoutSideMenu", LazyLayoutSideMenu],
["LayoutSidebar", LazyLayoutSidebar],
["LayoutStoreSearch", LazyLayoutStoreSearch],
["LayoutTopNavigation", LazyLayoutTopNavigation],
["LayoutTopNavigationRecursive", LazyLayoutTopNavigationRecursive],
["LayoutFooterBackToTop", LazyLayoutFooterBackToTop],
["LayoutFooterCopyright", LazyLayoutFooterCopyright],
["LayoutFooterCustomerService", LazyLayoutFooterCustomerService],
["LayoutFooterHorizontalLine", LazyLayoutFooterHorizontalLine],
["LayoutFooterNavigationMenu", LazyLayoutFooterNavigationMenu],
["LayoutFooterOverlay", LazyLayoutFooterOverlay],
["LayoutFooterPaymentMethods", LazyLayoutFooterPaymentMethods],
["LayoutFooterPaymentMethodsMobile", LazyLayoutFooterPaymentMethodsMobile],
["LayoutFooterSocialMedia", LazyLayoutFooterSocialMedia],
["LayoutHeaderInformationBanner", LazyLayoutHeaderInformationBanner],
["LayoutHeaderMenuScroll", LazyLayoutHeaderMenuScroll],
["LayoutHeaderPromotion", LazyLayoutHeaderPromotion],
["LayoutHeaderRatingWidget", LazyLayoutHeaderRatingWidget],
["LayoutHeaderSidebarInformation", LazyLayoutHeaderSidebarInformation],
["LayoutHeaderUserActions", LazyLayoutHeaderUserActions],
["ListingFiltersListingFilter", LazyListingFiltersListingFilter],
["ListingFilters", LazyListingFilters],
["ListingFiltersPrice", LazyListingFiltersPrice],
["ListingFiltersProperties", LazyListingFiltersProperties],
["ListingFiltersRating", LazyListingFiltersRating],
["ListingFiltersShippingFree", LazyListingFiltersShippingFree],
["ListingFiltersSwProductListingFilter", LazyListingFiltersSwProductListingFilter],
["ListingFiltersSwProductListingFilters", LazyListingFiltersSwProductListingFilters],
["ProductCustomConfigurator", LazyProductCustomConfigurator],
["ProductCard", LazyProductCard],
["ProductGalleryModal", LazyProductGalleryModal],
["ProductReviews", LazyProductReviews],
["ProductReviewsForm", LazyProductReviewsForm],
["ProductSuggestSearch", LazyProductSuggestSearch],
["ProductUnits", LazyProductUnits],
["ProductSwVariantConfigurator", LazyProductSwVariantConfigurator],
["ProductConfiguratorAttributeDisplay", LazyProductConfiguratorAttributeDisplay],
["ProductConfiguratorAttributeExtentedDisplay", LazyProductConfiguratorAttributeExtentedDisplay],
["ProductConfiguratorBundleListing", LazyProductConfiguratorBundleListing],
["ProductConfiguratorConfigListing", LazyProductConfiguratorConfigListing],
["ProductConfiguratorConfigurationItems", LazyProductConfiguratorConfigurationItems],
["ProductConfiguratorLeatherPrice", LazyProductConfiguratorLeatherPrice],
["ProductConfiguratorPriceSummary", LazyProductConfiguratorPriceSummary],
["ProductConfiguratorZoomModel", LazyProductConfiguratorZoomModel],
["ProductConfiguratorDisplaysImageDisplay", LazyProductConfiguratorDisplaysImageDisplay],
["ProductConfiguratorDisplaysRadioDisplay", LazyProductConfiguratorDisplaysRadioDisplay],
["ProductConfiguratorDisplaysTextDisplay", LazyProductConfiguratorDisplaysTextDisplay],
["SharedCmsTextRender", LazySharedCmsTextRender],
["SharedGlossaryModal", LazySharedGlossaryModal],
["SharedIntlTelInput", LazySharedIntlTelInput],
["SharedProductRating", LazySharedProductRating],
["SharedAccountAddressForm", LazySharedAccountAddressForm],
["SharedAddressSelectionModal", LazySharedAddressSelectionModal],
["SharedButton", LazySharedButton],
["SharedCountryStateInput", LazySharedCountryStateInput],
["SharedImage", LazySharedImage],
["SharedLandingPageLink", LazySharedLandingPageLink],
["SharedListingProductPrice", LazySharedListingProductPrice],
["SharedModal", LazySharedModal],
["SharedPagination", LazySharedPagination],
["SharedPrice", LazySharedPrice],
["SharedYoutubeVideo", LazySharedYoutubeVideo],
["SkeletonsDefault", LazySkeletonsDefault],
["SkeletonsProductCard", LazySkeletonsProductCard],
["CmsGenericElement", LazyCmsGenericElement],
["CmsNoComponent", LazyCmsNoComponent],
["CmsBlockCategoryNavigation", LazyCmsBlockCategoryNavigation],
["CmsBlockCenterText", LazyCmsBlockCenterText],
["CmsBlockCustomForm", LazyCmsBlockCustomForm],
["CmsBlockDefault", LazyCmsBlockDefault],
["CmsBlockForm", LazyCmsBlockForm],
["CmsBlockImage", LazyCmsBlockImage],
["CmsBlockImageBubbleRow", LazyCmsBlockImageBubbleRow],
["CmsBlockImageCover", LazyCmsBlockImageCover],
["CmsBlockImageFourColumn", LazyCmsBlockImageFourColumn],
["CmsBlockImageGallery", LazyCmsBlockImageGallery],
["CmsBlockImageHighlightRow", LazyCmsBlockImageHighlightRow],
["CmsBlockImageSimpleGrid", LazyCmsBlockImageSimpleGrid],
["CmsBlockImageSlider", LazyCmsBlockImageSlider],
["CmsBlockImageText", LazyCmsBlockImageText],
["CmsBlockImageTextBubble", LazyCmsBlockImageTextBubble],
["CmsBlockImageTextCover", LazyCmsBlockImageTextCover],
["CmsBlockImageTextGallery", LazyCmsBlockImageTextGallery],
["CmsBlockImageTextRow", LazyCmsBlockImageTextRow],
["CmsBlockImageThreeColumn", LazyCmsBlockImageThreeColumn],
["CmsBlockImageThreeCover", LazyCmsBlockImageThreeCover],
["CmsBlockImageTwoColumn", LazyCmsBlockImageTwoColumn],
["CmsBlockProductDescriptionReviews", LazyCmsBlockProductDescriptionReviews],
["CmsBlockProductHeading", LazyCmsBlockProductHeading],
["CmsBlockProductThreeColumn", LazyCmsBlockProductThreeColumn],
["CmsBlockText", LazyCmsBlockText],
["CmsBlockTextHero", LazyCmsBlockTextHero],
["CmsBlockTextOnImage", LazyCmsBlockTextOnImage],
["CmsBlockTextTeaser", LazyCmsBlockTextTeaser],
["CmsBlockTextTeaserSection", LazyCmsBlockTextTeaserSection],
["CmsBlockTextThreeColumn", LazyCmsBlockTextThreeColumn],
["CmsBlockTextTwoColumn", LazyCmsBlockTextTwoColumn],
["CmsBlockVimeoVideo", LazyCmsBlockVimeoVideo],
["CmsBlockYoutubeVideo", LazyCmsBlockYoutubeVideo],
["CmsElementCustomForm", LazyCmsElementCustomForm],
["CmsElementImage", LazyCmsElementImage],
["CmsElementImageGallery3dPlaceholder", LazyCmsElementImageGallery3dPlaceholder],
["CmsElementImageSlider", LazyCmsElementImageSlider],
["CmsElementManufacturerLogo", LazyCmsElementManufacturerLogo],
["CmsElementProductBox", LazyCmsElementProductBox],
["CmsElementProductName", LazyCmsElementProductName],
["CmsElementText", LazyCmsElementText],
["CmsElementVimeoVideo", LazyCmsElementVimeoVideo],
["CmsElementYoutubeVideo", LazyCmsElementYoutubeVideo],
["ProductCardSkeleton", LazyProductCardSkeleton],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
